import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { AppError } from '../errors'

const url = import.meta.env.VITE_SUPABASE_URL?.trim()
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim()

export const isSupabaseConfigured = Boolean(url && publishableKey)

let client: SupabaseClient | null = null

export function getSupabase(): SupabaseClient {
  if (!isSupabaseConfigured) {
    throw new AppError(
      'CONFIGURATION_ERROR',
      'Backend belum dikonfigurasi. Salin .env.example ke .env.local dan isi publishable key Supabase.',
    )
  }
  client ??= createClient(url!, publishableKey!, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  })
  return client
}
